import { RootState } from 'data/root.reducers';
import { CollectionFunction } from './collectionFunction.types';

export const getCollectionFunctionPristineList = (state: RootState): CollectionFunction[] => state.cfs.pristineEntities;
export const getCollectionFunctionList = (state: RootState): CollectionFunction[] => state.cfs.cfs;
export const getCollectionFunction = (state: RootState): CollectionFunction | null => state.cfs.single;
export const getSelectedCollectionFunction = (state: RootState): (CollectionFunction[]) => state.cfs.selected;
